var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "go-list-item",
      staticStyle: { cursor: "pointer" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.emitToggleBookmark.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "go-card-sub",
          class: {
            selectedItem:
              _vm.getAddingReferenceDocuments.indexOf(_vm.formModel) !== -1,
          },
        },
        [
          _c("div", { staticClass: "go-card-body" }, [
            _c(
              "div",
              {
                staticClass: "go-card-title go-btn-doc-preview",
                staticStyle: { "min-height": "42px" },
                attrs: { role: "button", tabindex: "0" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      (_vm.formModel.title === "null" &&
                        _vm.formModel.description) ||
                        _vm.formModel.title ||
                        _vm.formModel.description ||
                        (!_vm.formModel.description && _vm.formModel.content)
                    ) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.formModel.description
              ? _c(
                  "div",
                  {
                    staticClass: "go-card-desc",
                    staticStyle: { "min-height": "42px" },
                  },
                  [_vm._v(_vm._s(_vm.formModel.description))]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.formModel.description && _vm.formModel.content
              ? _c(
                  "div",
                  {
                    staticClass: "go-card-desc",
                    staticStyle: { "min-height": "42px" },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.formModel.content) + "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isFileCard &&
            !_vm.formModel.content &&
            !_vm.formModel.description
              ? _c("div", {
                  staticClass: "go-card-desc",
                  staticStyle: { "min-height": "42px" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "go-block-footer" }, [
              _c(
                "div",
                {
                  staticClass: "go-card-info",
                  staticStyle: { display: "flex", "margin-top": "5px" },
                },
                [
                  _vm.isFileCard || (!_vm.isFileCard && !_vm.tempDate)
                    ? _c(
                        "div",
                        {
                          staticClass: "go-channel truncate",
                          staticStyle: {
                            "margin-right": "5px",
                            "max-width": "150px",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.formModel.channel))])]
                      )
                    : _vm.tempDate
                    ? _c(
                        "div",
                        {
                          staticClass: "go-channel truncate go-card-desc",
                          staticStyle: {
                            display: "-webkit-box",
                            "margin-right": "5px",
                            "margin-top": "0 !important",
                            "max-width": "90px",
                            "-webkit-line-clamp": "1 !important",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.formModel.channel))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.tempDate && !_vm.isFileCard) || _vm.isFileCard
                    ? _c(
                        "div",
                        {
                          staticClass: "go-datetime",
                          staticStyle: { "line-height": "1.5" },
                        },
                        [
                          _vm.tempDate && !_vm.isFileCard
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.formatDate(_vm.tempDate))),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isFileCard
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.formModel.fileSize)),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-elements" }, [
                _vm.isHasLink
                  ? _c(
                      "button",
                      {
                        staticClass: "btn go-btn-icon",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.openLink.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "go-tooltip-area",
                            attrs: {
                              "data-toggle": "tooltip",
                              title: _vm.$t("cdHome.t94"),
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "go-icon-20 go-icon-newwindow",
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: [
                      "btn go-btn-icon",
                      {
                        active:
                          _vm.getAddingReferenceDocuments.indexOf(
                            _vm.formModel
                          ) !== -1,
                      },
                    ],
                    attrs: { "data-toggle": "button", type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.emitToggleBookmark.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "go-tooltip-area go-toggle-off",
                        attrs: {
                          "data-toggle": "tooltip",
                          title: _vm.$t("cdHome.t93"),
                        },
                      },
                      [_c("i", { staticClass: "go-icon-20 go-icon-bookmark" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "go-tooltip-area go-toggle-on",
                        attrs: {
                          "data-toggle": "tooltip",
                          title: _vm.$t("cdHome.t92"),
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "go-icon-20 go-icon-bookmark-on",
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.removeAble
              ? _c(
                  "button",
                  {
                    staticClass: "btn go-btn-icon go-btn-close",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.emitRemove.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "go-icon-18 go-icon-close" })]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }